import { DepartmentViewModel } from '../../models'

export default function getDepartmentName(department: DepartmentViewModel): string {
    const groupName = (department.group) ? department.group.name : ''
    const departmentName = department.name || ''

    return `${groupName ? `${groupName} - ` : ''}${departmentName}`
}
